import Raven from 'raven-js';
import { useEffect } from 'react';
import { useDisplayedCurrencyCode } from '../../hooks/useCurrencies';
import { useTrialDiscountPromotion } from '../../hooks/useTrialDiscountPromotion';
import { Alert } from 'foundations-components/transitional/components/Alert';
import I18n from 'I18n';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { Text } from 'foundations-components/components/Text';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { FormattedIntlCurrency } from 'I18n/components/FormattedIntlCurrency';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { trackBannerInteraction } from '../../utils/tracking/trackingEventUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export const TrialDiscountBanner = ({
  screen
}) => {
  const currencyCode = useDisplayedCurrencyCode();
  const {
    shouldShowBanner,
    error,
    listPrice,
    discountedPrice,
    discountPercentage,
    expirationDate,
    promotionId,
    apiName
  } = useTrialDiscountPromotion({
    screen
  });
  useEffect(() => {
    if (error) {
      Raven.captureException(error);
    }
  }, [error]);
  useEffect(() => {
    if (shouldShowBanner && apiName && promotionId) {
      trackBannerInteraction({
        action: 'view',
        name: promotionId
      });
    }
  }, [apiName, promotionId, shouldShowBanner]);
  if (!shouldShowBanner) {
    return null;
  }
  return /*#__PURE__*/_jsx(Alert, {
    type: "info",
    titleText: I18n.text(`trialDiscountBanner.${screen}.title`, {
      discountPercentage
    }),
    children: /*#__PURE__*/_jsx(ButtonWrapper, {
      children: /*#__PURE__*/_jsx(Text, {
        as: "span",
        children: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "trialDiscountBanner.description",
          options: {
            discountedPrice: /*#__PURE__*/_jsx(FormattedIntlCurrency, {
              trailingZeroDisplay: "stripIfInteger",
              value: discountedPrice,
              currencyCode: currencyCode
            }),
            listPrice: /*#__PURE__*/_jsx(FormattedIntlCurrency, {
              trailingZeroDisplay: "stripIfInteger",
              value: listPrice,
              currencyCode: currencyCode
            }),
            expirationDate: expirationDate ? /*#__PURE__*/_jsx(FormattedDateTime, {
              value: expirationDate,
              format: "ll",
              type: "userTz"
            }) : null
          }
        })
      })
    })
  });
};